import __vue_component__$2 from '../Button/Button.vue.js';
import __vue_component__ from '../RichTextEditor/RichTextEditor.vue.js';
import __vue_component__$1 from '../Form/InlineErrorMessage.vue.js';

//
var script = {
  name: 'RichTextEditableRenderer',
  components: {
    RichTextEditor: __vue_component__,
    InlineErrorMessage: __vue_component__$1,
    Button: __vue_component__$2
  },
  props: {
    value: {
      type: [String, Object],
      default: ''
    },
    emptyFieldText: {
      type: String,
      default: 'Click to add description...'
    },
    placement: {
      type: String,
      default: 'right'
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      isEditing: false,
      isLoading: false,
      isDirty: false,
      content: undefined,
      error: undefined
    };
  },

  computed: {
    isDisabled() {
      return this.isLoading || !this.isDirty;
    }

  },
  watch: {
    value: {
      handler(value) {
        this.content = value;
      },

      immediate: true
    },

    content() {
      this.isDirty = true;
    }

  },
  methods: {
    onEditRequested() {
      this.isEditing = true;
    },

    onCancel() {
      this.isEditing = false;
      this.isLoading = false;
      this.isDirty = false;
      this.error = undefined;
      this.content = this.value;
    },

    saveInlineEdit(error) {
      this.isLoading = false;

      if (error) {
        this.error = error;
        return;
      }

      this.onCancel();
    },

    onSave() {
      this.isLoading = true;
      this.$emit('save-requested', this.content, this.saveInlineEdit);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/RichTextEditableRenderer.vue_rollup-plugin-vue=script.js